import * as marietta from '../../..';
import { CONTROL_ACTIONMODE } from '../../Constants';
import { SVGSprite } from '../../flash/display';
import { Stage } from '../../model';

class RoomMovePicker {
    viewObj: Element;

    moveFunc: Function;

    moveEndFunc: Function;

    index: number;

    x: number;

    y: number;

    rotation: number = 0;

    transformMatrix: string;

    public spt: SVGSprite;

    private moveMouseEvent: MouseEvent;

    /**
     * コンストラクタ
     * */
    constructor(targetSprite: SVGSprite, _index: number) {
      this.index = _index;
      // 描画
      this.viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      this.viewObj.setAttribute('width', '10');
      this.viewObj.setAttribute('height', '10');
      this.viewObj.setAttribute('x', '-5');
      this.viewObj.setAttribute('y', '-5');
      this.viewObj.setAttribute('stroke', '#3598DC');
      this.viewObj.setAttribute('stroke-width', '1');
      this.viewObj.setAttribute('fill', '#FFFFFF');
      this.viewObj.setAttribute('id', `itemController_wall_${_index}`);
      this.spt = new SVGSprite(this.viewObj);
      targetSprite.addChild(this.spt);

      // アクション
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      ua = null;
    }

    /**
 * マウスダウンされた
 * @param MouseEvent
 */
    onMouseDownMe = (e: MouseEvent) => {
      // 選択モードのときは、バブリングさせない
      if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode === CONTROL_ACTIONMODE.ACTIONMODE_SELECT_ITEM) {
        e.stopPropagation();
      }

      // ドラッグの開始
      e.preventDefault();
      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.addEventListener('touchmove', this.onMouseMoveMe, { passive: false });
        document.addEventListener('touchend', this.onMouseUpMe, { passive: false });
      } else {
        document.addEventListener('mousemove', this.onMouseMoveMe);
        document.addEventListener('mouseup', this.onMouseUpMe);
      }

      const scope: RoomMovePicker = this;

      // comment k.kubonaka
      // mousemoveハンドラのタイミングで描画処理を行うとIEで極端にFPS低下するため
      // 実際の描画処理は、SpriteのEnterFrame(setTimeOut)ベースで行う
      this.spt.onEnterFrame = (): void => {
        if (scope.moveMouseEvent != null) {
          scope.moveFunc(scope.moveMouseEvent, scope);
        }
      };
      ua = null;
    }

    /**
     * マウスが移動した
     */
    onMouseMoveMe = (e: MouseEvent&TouchEvent) => {
      const self:RoomMovePicker = this;
      e.preventDefault();
      this.moveMouseEvent = e;
      // this.moveFunc( e, this );
      // pad スマホ用タッチ座標修正
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        if (e.touches.length >= 2) {
          // self.deleteMe();
          self.onMouseUpMe(e);
          return;
        }
        e.preventDefault();
        Stage.refreshStageMouse(<any>e);
      }
    }

    /**
     * マウスがUPされた
     */
    onMouseUpMe = (e: MouseEvent) => {
      e.preventDefault();
      this.spt.deleteEnterFrame();
      this.moveMouseEvent = null;

      let ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        document.removeEventListener('touchmove', this.onMouseMoveMe);
        document.removeEventListener('touchend', this.onMouseUpMe);
      } else {
        document.removeEventListener('mousemove', this.onMouseMoveMe);
        document.removeEventListener('mouseup', this.onMouseUpMe);
      }
      ua = null;

      // 終了の処理
      this.moveEndFunc(e, this);

      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTranslate();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTranslate();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTranslate();
    }

    /**
 * 回転
 * @param 回転角度（度数）
 */
    rotate(angle: number) {
      this.rotation = angle;
      this.updateTranslate();
    }

    /**
     * Translateのアップデート
     */
    updateTranslate() {
      // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      let sc: number = 1 / root.scaleX;

      // iPad・スマホは掴みやすくする
      const ua = marietta.webcad.WebCADGlobal.userAgentManager;
      if (ua.isMobile || ua.isTablet) {
        sc *= 1.5; // 1.5倍の大きさにする
      }

      if (this.spt.element.getAttribute('transform') === (`matrix(${sc},0,0,${sc},${this.x},${this.y})`)) return;
      this.transformMatrix = `matrix(${sc},0,0,${sc},${this.x},${this.y})`;
      this.spt.element.setAttribute('transform', this.transformMatrix);
    }

    /**
     * ピッカーdiable
     */
    disableDragger() {
      this.viewObj.setAttribute('fill', '#cccccc');
      this.viewObj.setAttribute('stroke', '#FFFFFF');
    }

    /**
     * ピッカーenable
     */
    enableDragger() {
      this.viewObj.setAttribute('fill', '#FFFFFF');
      this.viewObj.setAttribute('stroke', '#3598DC');
    }

    /**
     * 表示ON
     */
    show() {
      this.spt.element.style.visibility = 'visible';
    }

    /**
         * 表示ON
         */
    hide() {
      this.spt.element.style.visibility = 'hidden';
    }
}
export default RoomMovePicker;
